import { useNavigate } from "react-router-dom";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-zinc-50 px-6">
      <h1 className="text-6xl font-bold text-brand-600">404</h1>
      <p className="mt-4 text-lg text-zinc-600">Oops! Page not found.</p>
      <button
        onClick={() => navigate("/")}
        className="mt-6 rounded-lg bg-brand-600 px-4 py-2 text-white hover:bg-brand-600/90"
      >
        Go Home
      </button>
    </div>
  );
}
